import React, { useState } from 'react';
import MUIDataTable from "mui-datatables";
import { useNavigate } from 'react-router-dom';

/* This component is used by pages: CampaignsPage and AllCodersPage */

function DataTable ({columns, data, route, title}) {

    const [tableBodyHeight] = useState("400px");

    const navigate = useNavigate();

    const options = {
        filter: true,
        filterType: "dropdown",
        tableBodyHeight,
        selectableRows: 'none',
        selectableRowsOnClick: true,
        setRowProps: () => ({ //TO DO: selected row data should transfer to corresponding page with that data.
          onMouseUp: () => {
            navigate(route); 
          }
        })
    };

  return (

    <MUIDataTable
        title={title}
        data={data}
        columns={columns}
        options={options}
    />
  
  );
}

export default DataTable;